module.exports = "/_next/static/images/greenDataCenters-aaf25d6ceeaf78974a0d42cf3d5ccc8e.webp";